import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import Select from 'react-select';
import InputMask from 'react-input-mask';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../i18n/getLocale';

class StaffRfmsReportAdjustHours extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      modal: false,
      data: [],
      data_modal: [],
      applicabilities_list: [],
      staff_list: [],
      origins_list: [],
      status_list: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.edit = this.edit.bind(this);
    this.loadData = this.loadData.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChangeApplicability(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;

      var header = this.refs.request_api.header('application/json');
      var self = this;
      this.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/aplicabilidade/colaboradores/listagens/'+event.value, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({staff_list: responseJson.data.staffs});
          self.handleAlert(responseJson.message, responseJson.status, 'closed');
        });
      });
    }
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/questionario/pesquisa/fadiga/listagens';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({applicabilities_list: responseJson.data.applicabilities_list});
          self.setState({origins_list: responseJson.data.origins_list});
          self.setState({status_list: responseJson.data.status_list});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }); /* Overlay */
    });
  }

  edit(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      date: this.state.date,
      staff_id: this.state.staff_id,
      applicability_id: this.state.applicability_id,
      status: this.state.status,
      origins: this.state.origins,
    };

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/fadiga/revisar/horarios/ponto', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
        }
        self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  
  render() {
    var self = this;
    return (
<div>
  <Topo promptInstall={this.props.promptInstall}></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">{this.locale.RelatoriosDeFadiga.RevisarHorariosDePonto.titulo}</h3>
      <hr/>
      <h4 className="bg-info" style={{padding: '10px'}}><i className="fa fa-fw fa-warning"></i> {this.locale.RelatoriosDeFadiga.RevisarHorariosDePonto.tituloUtilizeEstaFerramentaParaCorrigirOsReportes}
      <br/>
      <br/>
      {this.locale.RelatoriosDeFadiga.RevisarHorariosDePonto.tituloAtencaoCasoOReportNaoExistaDeveraSerCriado}</h4>
      <hr/>
      <form onSubmit={this.edit}>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.RelatoriosDeFadiga.RevisarHorariosDePonto.formulario.AplicabilidadeTipoDeColaborador}:</label>
              <Select
                className="form-field-name"
                name="applicability_id"
                value={this.state.applicability_id}
                searchable={true}
                required
                placeholder={this.locale.RelatoriosDeFadiga.RevisarHorariosDePonto.formulario.placeholder.SelecionarAplicabilidade}
                onChange={this.handleSelectChangeApplicability.bind(this, 'applicability_id')}
                options={this.state.applicabilities_list}
              />
            </div>
          </div>
          {this.state.applicability_id === 1 ?
            <div className="col-md-4">
              <div className="form-group">
                <label>{this.locale.RelatoriosDeFadiga.RevisarHorariosDePonto.formulario.Tripulantes135}:</label>
                <Select
                  className="form-field-name"
                  name="staff_id"
                  value={this.state.staff_id}
                  searchable={true}
                  placeholder={this.locale.RelatoriosDeFadiga.RevisarHorariosDePonto.formulario.placeholder.SelecionarTripulante}
                  onChange={this.handleSelectChange.bind(this, 'staff_id')}
                  options={this.state.staff_list}
                  required
                />
              </div>
            </div>
            : this.state.applicability_id === 4 ?
            <div className="col-md-4">
              <div className="form-group">
                <label>{this.locale.RelatoriosDeFadiga.RevisarHorariosDePonto.formulario.Tripulantes121}:</label>
                <Select
                  className="form-field-name"
                  name="staff_id"
                  value={this.state.staff_id}
                  searchable={true}
                  placeholder={this.locale.RelatoriosDeFadiga.RevisarHorariosDePonto.formulario.placeholder.SelecionarTripulante}
                  onChange={this.handleSelectChange.bind(this, 'staff_id')}
                  options={this.state.staff_list}
                  required
                />
              </div>
            </div>
            : this.state.applicability_id === 2 ?
            <div className="col-md-4">
              <div className="form-group">
                <label>{this.locale.RelatoriosDeFadiga.RevisarHorariosDePonto.formulario.Mecanicos}:</label>
                <Select
                  className="form-field-name"
                  name="staff_id"
                  value={this.state.staff_id}
                  searchable={true}
                  placeholder={this.locale.RelatoriosDeFadiga.RevisarHorariosDePonto.formulario.placeholder.SelecionarMecanico}
                  onChange={this.handleSelectChange.bind(this, 'staff_id')}
                  options={this.state.staff_list}
                  required
                />
              </div>
            </div>
            : this.state.applicability_id === 3 ?
            <div className="col-md-4">
              <div className="form-group">
                <label>{this.locale.RelatoriosDeFadiga.RevisarHorariosDePonto.formulario.Coordenadores}:</label>
                <Select
                  className="form-field-name"
                  name="staff_id"
                  value={this.state.staff_id}
                  searchable={true}
                  placeholder={this.locale.RelatoriosDeFadiga.RevisarHorariosDePonto.formulario.placeholder.SelecionarCoordenador}
                  onChange={this.handleSelectChange.bind(this, 'staff_id')}
                  options={this.state.staff_list}
                  required
                />
              </div>
            </div>
            :
            ''
          }
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.RelatoriosDeFadiga.RevisarHorariosDePonto.formulario.Data}:</label>
              <InputMask value={this.state.date} required maskChar={null} name="date" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date')} placeholder="" />
            </div>
          </div>
        </div>
        <hr/>
        <div>
          <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-search"></i> {this.locale.RelatoriosDeFadiga.RevisarHorariosDePonto.formulario.botaoRevisarHorarios}</button>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default StaffRfmsReportAdjustHours;



// WEBPACK FOOTER //
// ./src/Components/StaffRfmsReport/StaffRfmsReportAdjustHours.js